const auth = {
  signIn: "התחברות",
  signOut: "התנתקות",
  email: "אימייל",
  password: "סיסמה",
  forgotPassword: "שכחת סיסמה?",
  resetPassword: "איפוס סיסמה",
  resetSent: "נשלח קישור לאיפוס סיסמה",
  invalidCredentials: "אימייל או סיסמה שגויים",
  sessionExpired: "הסשן פג — יש להתחבר מחדש",
  welcomeBack: "ברוך שובך",
  signInToCommand: "התחבר למרכז הפיקוד",
  newPassword: "סיסמה חדשה",
  passwordUpdated: "הסיסמה עודכנה בהצלחה",
  otpCode: "קוד חד-פעמי",
  sendCode: "שלח קוד",
  verifyCode: "אימות קוד",
  codeSent: "קוד נשלח לאימייל שלך",
  invalidCode: "קוד שגוי — נסה שוב",
  resendCode: "שלח קוד חדש",
  or: "או",
  signInWithGoogle: "התחבר עם Google",
  signInWithGithub: "התחבר עם GitHub",
  signInWithFacebook: "התחבר עם Facebook",
  signInWithMicrosoft: "התחבר עם Microsoft",
  signInWithApple: "התחבר עם Apple",
  signInWithLinkedIn: "התחבר עם LinkedIn",
  continueWith: "או התחבר באמצעות",
  createAccount: "יצירת חשבון",
  registerSubtitle: "הרשמה למרכז הפיקוד",
  alreadyHaveAccount: "כבר יש לך חשבון? התחבר",
  displayName: "שם מלא",
  displayNamePlaceholder: "השם שלך",
  profileSetup: "הגדרת פרופיל",
  completeRegistration: "סיום הרשמה",
  changeEmail: "שנה אימייל",
  unauthorized: "אין הרשאה לגשת למערכת",
  inviteOnly: "הגישה למערכת בהזמנה בלבד",
  accountPending: "החשבון שלך ממתין לאישור",
} as const;
export default auth;
